import React from 'react';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import styles from './SidebarSection.module.scss';

// Groups a set of SidebarNavRow items under an uppercase eyebrow label
// (hidden in the icon-only collapsed state). Renders nothing if every item
// underneath it was filtered out, so role/plan-based filtering never leaves
// a dangling section header with no rows beneath it.
export const SidebarSection = ({ label, collapsed, children }) => {
  const hasContent = React.Children.toArray(children).some(Boolean);
  if (!hasContent) return null;

  return (
    <div className={styles.section}>
      {!collapsed && (
        <Text
          variant={textVariantsEnum.Text_xxs}
          fontWeight={fontWeightEnum.Semibold}
          className={styles.sectionLabel}
        >
          {label}
        </Text>
      )}
      <div className={styles.sectionBody}>{children}</div>
    </div>
  );
};

SidebarSection.displayName = 'SidebarSection';
